const baseUrl = process.env.apiURL || "https://backend.melodahouse.com/api/v1";
const apiUri= `${baseUrl}/admin`;

export default apiUri;
// export default "https://api.learntocodewith.me/api/v1";